'use client';

import { createContext, ReactNode, useContext, useState } from 'react';
import { SetState, TState } from '@/types';
import { defaultStoreState } from './utils/constants';

const StoreContext = createContext<[TState, SetState] | undefined>(undefined);

export function StoreProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<TState>(defaultStoreState);

  return (
    <StoreContext.Provider value={[state, setState]}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}
